export const MS_URL = {
  ADMIN: 'administracion',
  CONSUMPTION: 'consumos',
  PREDICTION: 'prediccion',
};

export const ADMIN_SERVICES = {
  //TODO create admin services (app.settings)
  RELEVANT_MARKETS: 'mercados-relevantes',
  EXIT_POINTS: 'puntos-salida',
  CALORIFIC_POWER: 'puntos-poder-calorifico',
  CITIES: 'ciudades-provincias',
  SOCIETY: 'sociedades',
  VANTI_MARKETS: 'mercados-vanti',
  GI_ZONE: 'zonas-gi',
  CUSTOMERS_GET_ALL: 'clientes',
  COMPLEX_FILTERS: 'clientes/filters',
  SECTIONS: 'tramos',
  GAS_SOURCES: 'fuentes',
  SOCIETIES: 'sociedades',
  DISTRIBUTION_SYSTEM: 'sistemas-distribucion',
  METER_VERIFICATION: 'consolidado-medidor/verify',
  SUPPLY_CONTRACTS: 'contratos-suministro',
  TRANSPORT_CONTRACTS: 'contratos-transporte',
};

export const CONSUMPTION_SERVICES = {
  STATUS: 'consumo/estado',
  GENERAL: 'consumo/get/all',
  GENERAL_FILTERS: 'consumo/get',
  MASSIVE: 'consumo/gnvmas',
  LOSS: 'perdida',
  LOSS_STATUS: 'perdida',
  CONSOLIDATED: 'consolidado',
  HISTORIC: 'traza',
};

export const PREDICTION_SERVICES = {
  CALENDAR_TAGS: 'calendario/etiquetas',
  CALENDAR_ASSIGNMENT: 'calendario/asignacion',
  CALENDAR_PREDICTION: 'calendario/prediccion',
  CALENDAR_HOLIDAYS: 'calendario/festivos',
};

export const SECTIONS = {};
